import { getBffUrl } from './EnvironmentUtils';

/**
 * Clears HMRC user-delegated tokens on the BFF for the current Review user (cookies unchanged).
 * Call while the Review session is still active, before redirecting to the IdP logout URL.
 */
export async function clearPillar2UkAuthOnBff(host: string, enterpriseKey?: string | number): Promise<void> {
    const baseURL = getBffUrl(host);
    await fetch(`${baseURL}/pillar2/gb/auth/logout`, {
        method: 'POST',
        headers: {
            'x-csrf': '1',
            'x-enterprise-key': enterpriseKey?.toString() ?? '',
            Accept: 'application/json, text/plain',
        },
        credentials: 'include',
    });
}
